import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Reveal, MaskLine } from "@/components/Reveal";

export default function PageShell({ eyebrow, title, updated, children, testid }) {
  const navigate = useNavigate();
  return (
    <section data-testid={testid} className="pt-28 pb-24 lg:pt-36 lg:pb-32">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <p className="eyebrow mb-5">{eyebrow}</p>
        </Reveal>
        <h1 className="font-display font-medium leading-[1.02] tracking-tight text-4xl sm:text-5xl">
          <MaskLine inView={false}>{title}</MaskLine>
        </h1>
        {updated && (
          <p
            data-testid="page-updated"
            className="font-mono-accent text-[10px] tracking-[0.22em] uppercase text-[#1C130E]/50 mt-6"
          >
            Last updated · {updated}
          </p>
        )}
        <div className="mt-12 space-y-9 text-[15px] leading-relaxed text-[#1C130E]/80 [&_h2]:font-display [&_h2]:text-2xl [&_h2]:tracking-tight [&_h2]:text-[#1C130E] [&_h2]:font-medium [&_h2]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-1.5 [&_strong]:text-[#1C130E]">
          {children}
        </div>
        <button
          type="button"
          data-testid="page-back-home"
          onClick={() => {
            navigate("/");
            window.scrollTo(0, 0);
            if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
          }}
          className="group mt-14 inline-flex items-center gap-2 rounded-full border border-[rgba(28,19,14,0.25)] px-7 py-3.5 text-sm font-semibold hover:border-[#C85A32] hover:text-[#C85A32] transition-colors"
        >
          <ArrowLeft size={15} className="transition-transform duration-300 group-hover:-translate-x-0.5" />
          Back to home
        </button>
      </div>
    </section>
  );
}
